<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="学员姓名"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.enterpriseLogo.length!==0">
            <va-card
              overlay
              :image='insertData.enterpriseLogo'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-card title='企业logo'>
              <va-file-upload
                type='single'
                v-model='insertData.enterpriseLogoArr'
                @input="uploadEnterpriseImage"
              />
            </va-card>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.enterprise"
              label="企业名"
              removable
              :messages="message"
              :error="!!error.enterpriseErrors.length"
              :error-messages="error.enterpriseErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.serviceName"
              label="服务名称"
              removable
              :messages="message"
              :error="!!error.serviceNameErrors.length"
              :error-messages="error.serviceNameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.joinedProject"
              label="参与项目"
              removable
              :messages="message"
              :error="!!error.joinedProjectErrors.length"
              :error-messages="error.joinedProjectErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越小越靠前"
              removable
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
              type="number"
              :min="1"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import uploadApi from '../../api/upload'
import { copyObject } from '../../utils/common'
import offerManageApi from '../../api/offerManage'

export default {
  data () {
    return {
      insertData: {
        id: null,
        name: '',
        enterprise: '',
        enterpriseLogoArr: [],
        enterpriseLogo: '',
        serviceName: '',
        joinedProject: '',
        sortNum: null,
      },
      message: ['Required field'],
      error: {
        nameErrors: [],
        enterpriseErrors: [],
        serviceNameErrors: [],
        joinedProjectErrors: [],
        sortNumErrors: [],
      },
      title: '新增offer',
      showId: false,
      submitButtonStatus: true,
    }
  },
  created () {
    const params = this.$route.params
    console.log(this.insertData)
    if (params.id != null) {
      this.showId = true
      this.title = '编辑offer'
      // 通过id获取详情
      offerManageApi.getOfferManage(params.id).then(response => {
        copyObject(response, this.insertData)
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.enterpriseErrors.length &&
          !this.error.serviceNameErrors.length &&
          !this.error.joinedProjectErrors.length &&
          !this.error.sortNumErrors.length
    },
  },
  methods: {
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      if (this.insertData.enterpriseLogo.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        enterprise: this.insertData.enterprise,
        enterpriseLogo: this.insertData.enterpriseLogo,
        serviceName: this.insertData.serviceName,
        joinedProject: this.insertData.joinedProject,
        sortNum: this.insertData.sortNum,
      }
      if (this.insertData.id !== null) {
        data.id = this.insertData.id
        offerManageApi.updateOfferManage(this.insertData.id, data).then(response => {
          this.$router.push({ name: 'listOfferManage' })
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      } else {
        offerManageApi.saveOfferManage(data).then(response => {
          this.$router.push({ name: 'listOfferManage' })
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      }
    },
    uploadEnterpriseImage () {
      if (this.insertData.enterpriseLogoArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.enterpriseLogoArr[0])
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData.enterpriseLogo = response.url
      })
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.enterpriseErrors = this.insertData.enterprise ? [] : ['enterprise is required']
      this.error.serviceNameErrors = this.insertData.serviceName ? [] : ['serviceName is required']
      this.error.joinedProjectErrors = this.insertData.joinedProject ? [] : ['joinedProject is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    handleAttachmentChanges (event) {
      const file = event.attachment.file
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', file)
      uploadApi.uploadImage(formData).then(response => {
        event.attachment.setAttributes({ url: response.url })
      }).catch(error => {
        console.log(error)
      })
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
